import di from 'Services/di.js';

export default (obj) => {
    const { store } = di;
    const { reducerUser } = store.getState();
    return obj.owner ? `${obj.owner}` : `${reducerUser.name}`;
};
